import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import clsx from "clsx";
import { Modal, Box, TextField } from "@mui/material";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import { routes } from "../../constants/routes";
import Import from "./Import";
import Brand from "./Brand";
import { gpColors } from "../../constants/colors";
import Button from "@material-ui/core/Button";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import GP_Final_logo_transparent_background from "../../Images/GP_Final_logo_transparent_background.png";
// import { useEffect } from "react";
// import CryptoAES from "crypto-js/aes";
// import CryptoENC from "crypto-js/enc-utf8";
// import { getCookie } from "../../Functions";
import {
  Category,
  GroupAdd,
  PeopleAlt,
  FileCopy,
  Description,
  Scanner,
} from "@material-ui/icons";
import DashboardIcon from "@material-ui/icons/Dashboard";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import BookmarkIcon from "@material-ui/icons/Bookmark";
import BookmarkBorderIcon from "@material-ui/icons/BookmarkBorder";
import AddProductValMOdal from "./AddProductValMOdal";
import { getCookie } from "../../Functions";
import CryptoAES from "crypto-js/aes";
import CryptoENC from "crypto-js/enc-utf8";
// import {ExpandLess, ExpandMore } from "@mui/icons-material";
import { Collapse } from "@mui/material";
import Cookies from "js-cookie";

const drawerWidth = 280;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100vh",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: gpColors.logoBrown,
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  mobileDrawer: {
    display: "block",
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },

  content: {
    backgroundColor: "#EAE4E8",
    flexGrow: 1,
    paddingTop: "84px",
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  menuRoot: {
    flexGrow: 1,
  },
  paper: {
    marginRight: theme.spacing(2),
  },
  fieldBox: {
    width: "100%",
    margin: 5,
    [theme.breakpoints.only("xs")]: {
      width: "100%",
    },
    [theme.breakpoints.only("sm")]: {
      width: "100%",
    },
  },
  textFieldStyle: {
    width: "100%",
    height: "40px",
  },
}));

const SideDrawer = ({ tabName, userData1, drawerClose }) => {
  const classes = useStyles();
  const location = useLocation();
  const theme = useTheme();
  const navigate = useNavigate();
  const [brand, setBrand] = useState(true);
  const [importComp, setImportComp] = useState(false);
  const [open, setOpen] = React.useState(true);
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [userInfo, setUserInfo] = useState({});
  const anchorRef = React.useRef(null);
  const [role, setRole] = useState("");
  const [accessId, setAccessId] = useState("");
  const [openScan, setOpenScan] = useState(false);
  const [selectedSubTab, setSelectedSubTab] = useState("");
  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [token, setToken] = useState();
  const [validationModal, setValidationModal] = useState(false);
  const [alert, setAlert] = useState({
    alertStatus: false,
    alertColor: "green",
    alertMessage: "",
  });
  const [userData, setUserData] = useState({});

  //Getting cookies
  // const sessionCookie = Cookies.get("guradPlus_session");
  // const sessionUsername = Cookies.get("userName");
  // const getLoginInfoData = () => {
  //   const sessionData = JSON.parse(sessionCookie);
  //   if (sessionData !== null) {
  //     setRole(sessionData.role);
  //     setAccessId(sessionData.accessId);
  //     setToken(sessionData.jwt);
  //     setUserData({ username: sessionUsername });
  //   }
  // };

  // session storage
  const storedSession = sessionStorage.getItem("guradPlus_session");
let sessionToken = null;
let sessionRole = null;
let sessionAccessId = null;
let sessionUsername = null;

if (storedSession) {
  const parsed = JSON.parse(storedSession);
  const data = parsed.sessionData; // 🔹 access nested object
  sessionToken = data?.jwt || null;
  sessionRole = data?.role || null;
  sessionAccessId = data?.accessId || null;
  sessionUsername = sessionStorage.getItem("userName");
}

const getLoginInfoData = () => {
  if (sessionToken) {
    setRole(sessionRole);
    setAccessId(sessionAccessId);
    setToken(sessionToken);
    setUserData({ username: sessionUsername });
  }
};

  // old
  // const getLoginInfoData = () => {
  //   const getValue = getCookie("guardPlus_user");
  //   console.log('drawer get value: ', getValue)
  //   if (getValue !== null) {
  //     const decryptedValue = CryptoAES.decrypt(getValue, "secretKey");
  //     const userVal = JSON.parse(decryptedValue.toString(CryptoENC));
  //     setRole(userVal.loginInfo.data.role);
  //     setAccessId(userVal.loginInfo.data.accessId);
  //     setToken(userVal.loginInfo.data.jwt);
  //           setUserData(userVal);

  //   }
  // };

  useEffect(() => {
    if (location.pathname === routes.INWARD_SCAN) {
      setOpenScan(true);
      setSelectedSubTab("inward");
    } else if (location.pathname === routes.OUTWARD_SCAN) {
      setOpenScan(true);
      setSelectedSubTab("outward");
    }
  }, [location.pathname]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    getLoginInfoData();
  }, []);

  useEffect(() => {
    if (drawerClose) {
      setOpen(false);
    }
  }, [drawerClose]);

  const handleToggle = () => {
    console.log("handleToggle called");
    setMenuOpen((prevOpen) => !prevOpen);
  };
  function closeValidationModal() {
    setValidationModal(false);
  }
  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({
      ...alert,
      alertStatus: false,
      alertColor: "",
      alertMessage: "",
    });
  };
  const closeChangePassModal = () => {
    setOpenChangePassword(false);
    setNewPass("");
    setConfirmPass("");
  };
  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setMenuOpen(false);
    setOpenChangePassword(true);
  };
  const handleLogout = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    document.cookie =
      "guardPlus_user" + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    setMenuOpen(false);
    navigate(routes.GPADMIN);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setMenuOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(menuOpen);
  React.useEffect(() => {
    if (prevOpen.current === true && menuOpen === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = menuOpen;
  }, [menuOpen]);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    console.log("handleDrawerClose called");
    setOpen(false);
  };

  const handleChangePass = async () => {
    if (!newPass.trim() || !confirmPass.trim()) {
      setValidationModal(true);
      return;
    }

    if (newPass !== confirmPass) {
      setAlert({
        alertStatus: true,
        alertColor: "red",
        alertMessage: "Password and Confirm Password do not match.",
      });
      return;
    }

    try {
      const resp = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/changePassword`,
        {
          method: "POST",
          body: JSON.stringify({
            password: newPass.trim(),
            emailId: userData.username,
          }),
          headers: {
            Authorization: `Token ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await resp.json();

      if (data.result === "Success") {
        setOpenChangePassword(false);
        setAlert({
          alertStatus: true,
          alertColor: "green",
          alertMessage: "Password changed successfully!",
        });
      } else {
        setOpenChangePassword(false);
        setAlert({
          alertStatus: true,
          alertColor: "red",
          alertMessage: "Unable to change password. Please try again.",
        });
      }

      setNewPass("");
      setConfirmPass("");
    } catch (error) {
      setAlert({
        alertStatus: true,
        alertColor: "red",
        alertMessage: "Network error. Please try again later.",
      });
    }
  };

  return (
    <>
      {/* <div className={classes.root}> */}
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, {
              [classes.hide]: open,
            })}
          >
            <MenuIcon />
          </IconButton>
          <Typography className={classes.menuRoot}></Typography>
          <div>
            <Button
              ref={anchorRef}
              aria-controls={menuOpen ? "menu-list-grow" : undefined}
              aria-haspopup="true"
              onClick={handleToggle}
              style={{
                backgroundColor: gpColors.logoGray,
                color: "#fff",
                textTransform: "none",
              }}
              endIcon={<ArrowDropDownIcon />}
            >
              {userData.username}
            </Button>
            <Popper
              open={menuOpen}
              anchorEl={anchorRef.current}
              role={undefined}
              transition
              disablePortal
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === "bottom" ? "center top" : "center bottom",
                  }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={handleToggle}>
                      <MenuList
                        autoFocusItem={menuOpen}
                        id="menu-list-grow"
                        onKeyDown={handleListKeyDown}
                      >
                        <MenuItem onClick={handleClose}>
                          Change Password
                        </MenuItem>
                        <MenuItem onClick={handleLogout}>Logout</MenuItem>
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </div>
        </Toolbar>
      </AppBar>

      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <img
            src={GP_Final_logo_transparent_background}
            alt="logo"
            height="28px"
          />
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </div>
        <Divider />
        <List>
          {/* <ListItem
            style={{
              backgroundColor: tabName === "brand" ? gpColors.logoGray : "#fff",
              color: tabName === "brand" ? "#fff" : "#000",
            }}
            button
            onClick={() => {
              setBrand(true);
              setImportComp(false);
              navigate(routes.BRANDTYPE);
            }}
          >
            <ListItemIcon
              style={{ color: tabName === "brand" ? "#fff" : "#000" }}
            >
              <DashboardIcon />
            </ListItemIcon>
            <ListItemText primary="Brand Parts" style={{ fontWeight: 700 }} />
          </ListItem> */}
          {/* <ListItem
            style={{
              backgroundColor:
                tabName === "import" ? gpColors.logoGray : "#fff",
              color: tabName === "import" ? "#fff" : "#000",
            }}
            button
            onClick={() => {
              setImportComp(true);
              setBrand(false);
              navigate(routes.IMPORT);
            }}
          >
            <ListItemIcon
              style={{ color: tabName === "import" ? "#fff" : "#000" }}
            >
              <InboxIcon />
            </ListItemIcon>
            <ListItemText primary="Import" style={{ fontWeight: 700 }} />
          </ListItem> */}

          {role.trim() === "1" && (
            <>
              <ListItem
                style={{
                  backgroundColor:
                    tabName === "dashboard" ? gpColors.logoGray : "#fff",
                  color: tabName === "dashboard" ? "#fff" : "#000",
                }}
                button
                onClick={() => {
                  navigate(routes.DASHBOARD);
                }}
              >
                <ListItemIcon
                  style={{ color: tabName === "dashboard" ? "#fff" : "#000" }}
                >
                  <DashboardIcon />
                </ListItemIcon>
                <ListItemText primary="Dashboard" style={{ fontWeight: 700 }} />
              </ListItem>
              <ListItem
                style={{
                  backgroundColor:
                    tabName === "products" ? gpColors.logoGray : "#fff",
                  color: tabName === "products" ? "#fff" : "#000",
                }}
                button
                onClick={() => {
                  setImportComp(true);
                  setBrand(false);
                  navigate(routes.ADD_PRODUCTS);
                }}
              >
                <ListItemIcon
                  style={{ color: tabName === "products" ? "#fff" : "#000" }}
                >
                  <Category />
                </ListItemIcon>
                <ListItemText primary="Products" style={{ fontWeight: 700 }} />
              </ListItem>
              {/* ADD USERS */}
              <ListItem
                style={{
                  backgroundColor:
                    tabName === "addUsers" ? gpColors.logoGray : "#fff",
                  color: tabName === "addUsers" ? "#fff" : "#000",
                }}
                button
                onClick={() => {
                  navigate(routes.ADD_USERS);
                }}
              >
                <ListItemIcon
                  style={{ color: tabName === "addUsers" ? "#fff" : "#000" }}
                >
                  <GroupAdd />
                </ListItemIcon>
                <ListItemText primary="Add User" style={{ fontWeight: 700 }} />
              </ListItem>
              {/* Manage User */}
              <ListItem
                style={{
                  backgroundColor:
                    tabName === "manageUsers" ? gpColors.logoGray : "#fff",
                  color: tabName === "manageUsers" ? "#fff" : "#000",
                }}
                button
                onClick={() => {
                  navigate(routes.MANAGE_USERS);
                }}
              >
                <ListItemIcon
                  style={{ color: tabName === "manageUsers" ? "#fff" : "#000" }}
                >
                  <PeopleAlt />
                </ListItemIcon>
                <ListItemText
                  primary="Manage Users"
                  style={{ fontWeight: 700 }}
                />
              </ListItem>
              {/* Import UPC And CBM */}
              <ListItem
                style={{
                  backgroundColor:
                    tabName === "importUpcCbm" ? gpColors.logoGray : "#fff",
                  color: tabName === "importUpcCbm" ? "#fff" : "#000",
                }}
                button
                onClick={() => {
                  navigate(routes.UPC_CBM);
                }}
              >
                <ListItemIcon
                  style={{
                    color: tabName === "importUpcCbm" ? "#fff" : "#000",
                  }}
                >
                  <FileCopy />
                </ListItemIcon>
                <ListItemText
                  primary="Import UPC And CBM"
                  style={{ fontWeight: 700 }}
                />
              </ListItem>
              {/* ship to loc */}
              <ListItem
                style={{
                  backgroundColor:
                    tabName === "shipToLoc" ? gpColors.logoGray : "#fff",
                  color: tabName === "shipToLoc" ? "#fff" : "#000",
                }}
                button
                onClick={() => {
                  navigate(routes.SHIP_TO_LOC);
                }}
              >
                <ListItemIcon
                  style={{
                    color: tabName === "shipToLoc" ? "#fff" : "#000",
                  }}
                >
                  <LocationOnIcon />
                </ListItemIcon>
                <ListItemText
                  primary="Ship To Locations"
                  style={{ fontWeight: 700 }}
                />
              </ListItem>
            </>
          )}
          {/* Scan */}

          <ListItem
            style={{
              backgroundColor: "#fff",
              color: "#000",
            }}
            button
            onClick={() => {
              setOpenScan(!openScan);
            }}
          >
            <ListItemIcon style={{ color: "#000" }}>
              <Scanner />
            </ListItemIcon>
            <ListItemText primary="Scan" style={{ fontWeight: 700 }} />
            {openScan ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </ListItem>

          {/* Dropdown Items */}
          <Collapse in={openScan} timeout="auto" unmountOnExit>
            {(accessId === "1" || accessId === "3") && (
              <ListItem
                button
                onClick={() => {
                  setSelectedSubTab("inward");
                  navigate(routes.INWARD_SCAN);
                }}
                sx={{ pl: 4 }}
                style={{
                  backgroundColor:
                    selectedSubTab === "inward" ? gpColors.logoGray : "#fff",
                  color: selectedSubTab === "inward" ? "#fff" : "#000",
                }}
              >
                <ListItemIcon>
                  <BookmarkIcon
                    style={{
                      color: selectedSubTab === "inward" ? "#fff" : "#000",
                    }}
                  />
                </ListItemIcon>

                <ListItemText
                  className="list-item-text-box"
                  primary="Inward Scan"
                />
              </ListItem>
            )}
            {(accessId === "2" || accessId === "3") && (
              <ListItem
                button
                onClick={() => {
                  setSelectedSubTab("outward");
                  navigate(routes.OUTWARD_SCAN);
                }}
                sx={{ pl: 4 }}
                style={{
                  backgroundColor:
                    selectedSubTab === "outward" ? gpColors.logoGray : "#fff",
                  color: selectedSubTab === "outward" ? "#fff" : "#000",
                }}
              >
                <ListItemIcon>
                  <BookmarkBorderIcon
                    style={{
                      color: selectedSubTab === "outward" ? "#fff" : "#000",
                    }}
                  />
                </ListItemIcon>

                <ListItemText
                  className="list-item-text-box"
                  primary="Outward Scan"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                  }}
                />
              </ListItem>
            )}
          </Collapse>
          {/* Container Details */}
          <ListItem
            style={{
              backgroundColor:
                tabName === "containerDetails" ? gpColors.logoGray : "#fff",
              color: tabName === "containerDetails" ? "#fff" : "#000",
            }}
            button
            onClick={() => {
              navigate(routes.CONTAINER_DETAILS);
            }}
          >
            <ListItemIcon
              style={{
                color: tabName === "containerDetails" ? "#fff" : "#000",
              }}
            >
              <Description />
            </ListItemIcon>
            <ListItemText
              primary="Container Details"
              style={{ fontWeight: 700 }}
            />
          </ListItem>
        </List>
      </Drawer>

      <div className={classes.mobileDrawer}>
        <Drawer variant="persistent" anchor="left" open={open}>
          <div className={classes.toolbar}>
            <img
              src={GP_Final_logo_transparent_background}
              alt="logo"
              height="28px"
            />
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === "rtl" ? (
                <ChevronRightIcon />
              ) : (
                <ChevronLeftIcon />
              )}
            </IconButton>
          </div>
          <Divider />
          <List>
            {/* <ListItem
              style={{
                backgroundColor:
                  tabName === "brand" ? gpColors.logoGray : "#fff",
                color: tabName === "brand" ? "#fff" : "#000",
              }}
              button
              onClick={() => {
                setBrand(true);
                setImportComp(false);
                navigate(routes.BRANDTYPE);
              }}
            >
              <ListItemIcon
                style={{ color: tabName === "brand" ? "#fff" : "#000" }}
              >
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText primary="Brand Parts" style={{ fontWeight: 700 }} />
            </ListItem> */}
            {/* <ListItem
              style={{
                backgroundColor:
                  tabName === "import" ? gpColors.logoGray : "#fff",
                color: tabName === "import" ? "#fff" : "#000",
              }}
              button
              onClick={() => {
                setImportComp(true);
                setBrand(false);
                navigate(routes.IMPORT);
              }}
            >
              <ListItemIcon
                style={{ color: tabName === "import" ? "#fff" : "#000" }}
              >
                <InboxIcon />
              </ListItemIcon>
              <ListItemText primary="Import" style={{ fontWeight: 700 }} />
            </ListItem> */}

            {role.trim() === "1" && (
              <>
                <ListItem
                  style={{
                    backgroundColor:
                      tabName === "products" ? gpColors.logoGray : "#fff",
                    color: tabName === "products" ? "#fff" : "#000",
                  }}
                  button
                  onClick={() => {
                    setImportComp(true);
                    setBrand(false);
                    navigate(routes.ADD_PRODUCTS);
                    handleDrawerClose();
                  }}
                >
                  <ListItemIcon
                    style={{ color: tabName === "products" ? "#fff" : "#000" }}
                  >
                    <Category />
                  </ListItemIcon>
                  <ListItemText
                    primary="Products"
                    style={{ fontWeight: 700 }}
                  />
                </ListItem>
                {/* ADD USERS */}
                <ListItem
                  style={{
                    backgroundColor:
                      tabName === "addUsers" ? gpColors.logoGray : "#fff",
                    color: tabName === "addUsers" ? "#fff" : "#000",
                  }}
                  button
                  onClick={() => {
                    navigate(routes.ADD_USERS);
                    setOpen(false);
                  }}
                >
                  <ListItemIcon
                    style={{ color: tabName === "addUsers" ? "#fff" : "#000" }}
                  >
                    <GroupAdd />
                  </ListItemIcon>
                  <ListItemText
                    primary="Add User"
                    style={{ fontWeight: 700 }}
                  />
                </ListItem>
                {/* Manage User */}
                <ListItem
                  style={{
                    backgroundColor:
                      tabName === "manageUsers" ? gpColors.logoGray : "#fff",
                    color: tabName === "manageUsers" ? "#fff" : "#000",
                  }}
                  button
                  onClick={() => {
                    navigate(routes.MANAGE_USERS);
                  }}
                >
                  <ListItemIcon
                    style={{
                      color: tabName === "manageUsers" ? "#fff" : "#000",
                    }}
                  >
                    <PeopleAlt />
                  </ListItemIcon>
                  <ListItemText
                    primary="Manage Users"
                    style={{ fontWeight: 700 }}
                  />
                </ListItem>
                {/* Import UPC And CBM */}
                <ListItem
                  style={{
                    backgroundColor:
                      tabName === "importUpcCbm" ? gpColors.logoGray : "#fff",
                    color: tabName === "importUpcCbm" ? "#fff" : "#000",
                  }}
                  button
                  onClick={() => {
                    navigate(routes.UPC_CBM);
                  }}
                >
                  <ListItemIcon
                    style={{
                      color: tabName === "importUpcCbm" ? "#fff" : "#000",
                    }}
                  >
                    <FileCopy />
                  </ListItemIcon>
                  <ListItemText
                    primary="Import UPC And CBM"
                    style={{ fontWeight: 700 }}
                  />
                </ListItem>
                {/* ship to loc */}
                <ListItem
                  style={{
                    backgroundColor:
                      tabName === "shipToLoc" ? gpColors.logoGray : "#fff",
                    color: tabName === "shipToLoc" ? "#fff" : "#000",
                  }}
                  button
                  onClick={() => {
                    navigate(routes.SHIP_TO_LOC);
                  }}
                >
                  <ListItemIcon
                    style={{
                      color: tabName === "shipToLoc" ? "#fff" : "#000",
                    }}
                  >
                    <LocationOnIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Ship To Locations"
                    style={{ fontWeight: 700 }}
                  />
                </ListItem>
              </>
            )}
            {/* Scan */}
            {/* <ListItem
              style={{
                backgroundColor:
                  tabName === "scan" ? gpColors.logoGray : "#fff",
                color: tabName === "scan" ? "#fff" : "#000",
              }}
              button
              onClick={() => {
                navigate(routes.SCAN);
              }}
            >
              <ListItemIcon
                style={{ color: tabName === "scan" ? "#fff" : "#000" }}
              >
                <Scanner />
              </ListItemIcon>
              <ListItemText primary="Scan" style={{ fontWeight: 700 }} />
            </ListItem> */}
            <ListItem
              style={{
                backgroundColor: "#fff",
                color: "#000",
              }}
              button
              onClick={() => {
                setOpenScan(!openScan);
              }}
            >
              <ListItemIcon style={{ color: "#000" }}>
                <Scanner />
              </ListItemIcon>
              <ListItemText primary="Scan" style={{ fontWeight: 700 }} />
              {openScan ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </ListItem>
            {/* Dropdown Items */}
            <Collapse in={openScan} timeout="auto" unmountOnExit>
              {(accessId === "1" || accessId === "3") && (
                <ListItem
                  button
                  onClick={() => {
                    setSelectedSubTab("inward");
                    navigate(routes.INWARD_SCAN);
                  }}
                  sx={{ pl: 4 }}
                  style={{
                    backgroundColor:
                      selectedSubTab === "inward" ? gpColors.logoGray : "#fff",
                    color: selectedSubTab === "inward" ? "#fff" : "#000",
                  }}
                >
                  <ListItemIcon>
                    <BookmarkIcon
                      style={{
                        color: selectedSubTab === "inward" ? "#fff" : "#000",
                      }}
                    />
                  </ListItemIcon>

                  <ListItemText
                    className="list-item-text-box"
                    primary="Inward Scan"
                  />
                </ListItem>
              )}
              {(accessId === "2" || accessId === "3") && (
                <ListItem
                  button
                  onClick={() => {
                    setSelectedSubTab("outward");
                    navigate(routes.OUTWARD_SCAN);
                  }}
                  sx={{ pl: 4 }}
                  style={{
                    backgroundColor:
                      selectedSubTab === "outward" ? gpColors.logoGray : "#fff",
                    color: selectedSubTab === "outward" ? "#fff" : "#000",
                  }}
                >
                  <ListItemIcon>
                    <BookmarkBorderIcon
                      style={{
                        color: selectedSubTab === "outward" ? "#fff" : "#000",
                      }}
                    />
                  </ListItemIcon>

                  <ListItemText
                    className="list-item-text-box"
                    primary="Outward Scan"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-start",
                    }}
                  />
                </ListItem>
              )}
            </Collapse>

            {/* containerDetails */}
            <ListItem
              style={{
                backgroundColor:
                  tabName === "containerDetails" ? gpColors.logoGray : "#fff",
                color: tabName === "containerDetails" ? "#fff" : "#000",
              }}
              button
              onClick={() => {
                navigate(routes.CONTAINER_DETAILS);
              }}
            >
              <ListItemIcon
                style={{
                  color: tabName === "containerDetails" ? "#fff" : "#000",
                }}
              >
                <Description />
              </ListItemIcon>
              <ListItemText
                primary="Container Details"
                style={{ fontWeight: 700 }}
              />
            </ListItem>
          </List>
        </Drawer>

        {/* change password popup */}
        <Modal
          open={openChangePassword}
          onClose={closeChangePassModal}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "background.paper",
              borderRadius: 10,
              boxShadow: 24,
              p: 4,
            }}
          >
            <Box display="flex" flexWrap="wrap">
              <Typography
                variant="h6"
                component="h2"
                style={{
                  fontWeight: "bold",
                  marginBottom: "20px",
                  width: "100%",
                }}
              >
                Change Password
              </Typography>
              <Box className={classes.fieldBox}>
                <Typography>
                  New Password : <label style={{ color: "red" }}>*</label>
                </Typography>
                <TextField
                  type="password"
                  variant="outlined"
                  size="small"
                  className={classes.textFieldStyle}
                  name="firstName"
                  value={newPass}
                  onChange={(e) => setNewPass(e.target.value)}
                />
              </Box>
              <Box className={classes.fieldBox}>
                <Typography>
                  Confirm Password : <label style={{ color: "red" }}>*</label>
                </Typography>
                <TextField
                  type="password"
                  variant="outlined"
                  size="small"
                  className={classes.textFieldStyle}
                  name="lastName"
                  value={confirmPass}
                  onChange={(e) => setConfirmPass(e.target.value)}
                />
              </Box>
            </Box>
            <Box display="flex" justifyContent="center" mt={4}>
              <Button
                style={{
                  backgroundColor: "#F22F46",
                  color: "#fff",
                  width: "50%",
                  fontSize: 16,
                  textTransform: "none",
                }}
                onClick={handleChangePass}
              >
                Change Password
              </Button>
            </Box>
          </Box>
        </Modal>
      </div>
      {/* <main className={classes.content}>
         <div className={classes.toolbar} />
         {brand && <Brand/>}
         {importComp && <Import loginInfo={userInfo.loginInfo.data}/>}
        
      </main> 
     </div> */}
      <AddProductValMOdal
        validationModal={validationModal}
        closeValidationModal={closeValidationModal}
        handleAlertClose={handleAlertClose}
        alert={alert}
      />
    </>
  );
};
export default SideDrawer;
